import React, { useState, useEffect, useRef } from "react";
import { Eye, ArrowLeft, User } from "lucide-react";
import Header from "./Header.js";
import Search from "../assets/search.png";
import Loader from "./Loader.js";
import DatePicker from "react-datepicker";
import GreyArrow from "../assets/greyLeftAr.png";
import { ViewStaffPagesText } from "../CommonJquery/WebsiteText.js";
import {
  server_post_data,
  get_oilcheck_data_new,
} from "../ServiceConnection/serviceconnection.js";
import "../Components/Css/Maintanance.css";
import {
  computeTodayDate,
  handleError,
  handleIaphabetnumberChange,
  mondayDayYearFormat,
  computeplussevendays,
  goBack,
  formatToYYYYMMDD,
} from "../CommonJquery/CommonJquery.js";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import "./Css/Maintancelog.css";

const OilCheckLog = ({ sharedValue }) => {
  const navigate = useNavigate();
  let flag = "1";
  let { id } = useParams();
  const call_id = id;

  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  const [flagData, setflagData] = useState("1");

  let formattedSevenDaysAgo = computeplussevendays();
  let formattedToday = computeTodayDate();
  if (sharedValue !== null && sharedValue !== undefined) {
    formattedToday = sharedValue;
    formattedSevenDaysAgo = sharedValue;
    flag = "2";
  }

  const [startDate, setStartDate] = useState(formattedSevenDaysAgo);
  const [endDate, setEndDate] = useState(formattedToday);
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [selectedValue, setSelectedValue] = useState("Name");
  const [ImageLink, setImageLink] = useState("");
  const [ImageLinkIpass, setImageLinkIpass] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Calculate pagination data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  //console.log("currentItems logs", currentItems);
  const handlePageChange = (pageNumber) => {
    // Ensure page number is within valid range
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  const search_data = () => {
    flag = "1";
    // const call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    //console.log("logs fetch runs");
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("end_date", formatToYYYYMMDD(end_date));
    fd.append("flag", flag);
    fd.append("call_id", call_id);

    try {
      const Response = await server_post_data(get_oilcheck_data_new, fd);
      if (Response.data.error) {
        handleError(Response.data.message);
      } else {
        seteditStaffData(Response.data.message.data);
        setfilteredData(Response.data.message.data);
        setImageLink(Response.data.message.image_link);
        setImageLinkIpass(Response.data.message.ipass_link);
        setCurrentPage(1); // Reset to first page on new search
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    if (editStaffData && editStaffData.length > 0) {
      const filteredDatashow = editStaffData.filter((row) => {
        return Object.values(row).some((value) => {
          if (value !== null && value !== undefined) {
            return (
              typeof value === "string"
                ? value.toLowerCase()
                : value.toString().toLowerCase()
            ).includes(searchValue.toLowerCase());
          }
          return false;
        });
      });

      setfilteredData(filteredDatashow);
      setCurrentPage(1); // Reset to first page on filter change
    }
  };

  const buttonRef = useRef(null);
  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.click();
      master_data_get(startDate, endDate, flagData, call_id);
    }
    //console.log("useeffect runs");
  }, []);

  const handleNavigateBack = (option) => {
    navigate("/ViewOilCheck", {
      state: {
        data: option,
        ImageLink: ImageLink,
        ImageLinkIpass: ImageLinkIpass,
      },
    });
    // navigate("/ViewRepair");
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  return (
    <>
      <Header />
      {showLoaderAdmin && <Loader />}

      <div className="maintancelog-container">
        <div className="maintancelog-content">
          <div className="maintancelog-content-container">
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <div className="d-flex gap-2 align-items-center">
                  <p>View Repair Logs</p>
                  <img
                    src={GreyArrow}
                    alt="Rapid Car Leasing"
                    style={{ height: "14px" }}
                  />
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="maintancelog-filters">
              <div className="maintancelog-filter-container">
                <div className="maintancelog-left-section">
                  <div className="maintancelog-date-container">
                    <label className="maintancelog-label">
                      {ViewStaffPagesText.Start_Date}
                    </label>
                    <div className="maintancelog-datepicker-wrapper">
                      <DatePicker
                        selected={startDate}
                        onChange={handleDateChange}
                        className="maintancelog-datepicker"
                        maxDate={computeTodayDate()}
                        dateFormat="MM-dd-yyyy"
                        placeholderText="MM-DD-YYYY"
                      />
                    </div>
                  </div>
                  <div className="maintancelog-date-container">
                    <label className="maintancelog-label">
                      {ViewStaffPagesText.End_Date}
                    </label>
                    <div className="maintancelog-datepicker-wrapper">
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        className="maintancelog-datepicker"
                        maxDate={computeTodayDate()}
                        minDate={startDate}
                        dateFormat="MM-dd-yyyy"
                        placeholderText="MM-DD-YYYY"
                      />
                    </div>
                  </div>

                  <div className="maintancelog-search-button-container">
                    <button
                      type="button"
                      className="maintancelog-search-button"
                      onClick={search_data}
                      ref={buttonRef}
                    >
                      {ViewStaffPagesText.Search_text}
                    </button>
                  </div>
                </div>
                <div className="maintancelog-right-section">
                  <div className="maintancelog-search-field">
                    <label
                      className="maintancelog-search-icon"
                      htmlFor="searchFilter"
                    >
                      <img src={Search} alt="Rapid Car Leasing" />
                    </label>
                    <input
                      id="searchFilter"
                      type="text"
                      placeholder={ViewStaffPagesText.Staff_Filter_reservation}
                      onInput={handleIaphabetnumberChange}
                      value={searchfilter}
                      onChange={handleSearch}
                      className="maintancelog-search-input"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="maintancelog-table-container">
              <div className="maintancelog-table-wrapper">
                <table className="maintancelog-table">
                  <thead className="maintancelog-table-header">
                    <tr>
                      <th scope="col">Sr.No.</th>
                      <th scope="col">Date</th>
                      <th scope="col">Service Type</th>
                      <th scope="col">Issues Reported</th>
                      <th scope="col">Mechanic</th>
                      <th scope="col">View Report</th>
                    </tr>
                  </thead>
                  <tbody className="maintancelog-table-body custum_border">
                    {currentItems.length > 0 ? (
                      currentItems.map((option, index) => (
                        <tr className="maintancelog-table-row" key={index}>
                          <td>
                            <div className="maintancelog-cell maintancelog-center">
                              <p>{indexOfFirstItem + index + 1}</p>
                            </div>
                          </td>
                          <td>
                            <div className="maintancelog-cell">
                              <p>
                                {mondayDayYearFormat(
                                  option?.entry_date || "NA"
                                )}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div className="maintancelog-cell">
                              {/* <p>{option.maintenance_reasion}</p> */}
                              <p>Oil Check</p>
                            </div>
                          </td>
                          <td>
                            <div className="maintancelog-cell">
                              <p>{option.name_and_issue}</p>
                            </div>
                          </td>
                          <td>
                            <div className="maintancelog-cell maintancelog-with-icon">
                              <User
                                className="maintancelog-icon"
                                strokeWidth={1.5}
                              />
                              <p className="m-0">{option.assign_staff_name}</p>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex">
                              <div className="maintancelog-cell maintancelog-action">
                                <button
                                  type="button"
                                  title="View Maintenance Details"
                                  onClick={() => handleNavigateBack(option)}
                                  className="maintancelog-view-button"
                                >
                                  <Eye size={20} strokeWidth={1.5} />
                                </button>
                              </div>
                              {/* <div className="maintancelog-cell maintancelog-action">
                                <button
                                  type="button"
                                  title="Edit Maintenance Details"
                                  onClick={() => handleNavigateEdit(option)}
                                  className="maintancelog-view-button"
                                >
                                  <Edit size={20} strokeWidth={1.5} />
                                </button>
                              </div> */}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="maintancelog-no-data">
                          No Results Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="cust_hist_card_footer">
              <div className="cust_hist_pagination_info">
                {filteredData && filteredData.length > 0 ? (
                  <>
                    Showing{" "}
                    <span className="cust_hist_pagination_bold">
                      {indexOfFirstItem + 1}
                    </span>{" "}
                    to{" "}
                    <span className="cust_hist_pagination_bold">
                      {Math.min(indexOfLastItem, filteredData.length)}
                    </span>{" "}
                    of{" "}
                    <span className="cust_hist_pagination_bold">
                      {filteredData.length}
                    </span>{" "}
                    rentals
                  </>
                ) : (
                  <>
                    Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                    rentals
                  </>
                )}
              </div>
              <div className="cust_hist_pagination">
                <nav aria-label="Pagination">
                  <ul className="cust_hist_pagination_list">
                    {renderPaginationButtons()}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OilCheckLog;
